// extracted by mini-css-extract-plugin
module.exports = {"recommendedBagWrapper":"style_recommendedBagWrapper__0z1Ey","title":"style_title__Acspf"};